// removed by extract-text-webpack-plugin
module.exports = {"about_box_photos":"about_box_photos__1E0ba","about_photos_section":"about_photos_section__2m-aZ","about_box_title":"about_box_title__2AO7V","about_photo_description":"about_photo_description__fFhIs","about_photo_image":"about_photo_image__3U6e-","about_photo_container":"about_photo_container__acl68","about_photo_image_half":"about_photo_image_half__3PLaR"};


//////////////////
// WEBPACK FOOTER
// ./components/about/style.scss
// module id = 3CUW
// module chunks = 9